import { render, staticRenderFns } from "./ProductRankingTable.vue?vue&type=template&id=4959fb0f&"
import script from "./ProductRankingTable.vue?vue&type=script&lang=js&"
export * from "./ProductRankingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports